export default __webpack_public_path__ + "static/Light-Exposure-2cf235bd57b6bcedb15588d898c6b1bb.svg";